import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { getParam } from './shared/constants/app-enums';
import { TranslateService } from '@ngx-translate/core';
import { EventService } from './services/event.service';

declare global {
  interface Window {
    dataLayer: any[];
  }
}
export var selectedLang: string;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {

  constructor(
    private meta: Meta,
    private title: Title,
    private eventService: EventService
  ) {
    getParam('clickId');
    getParam('source');

    this.meta.updateTag({ name: 'description', content: "XRP20 is a new ERC-20 token that brings staking utility and the chance to buy in presale 30 times cheaper than original XRP’s all-time low." });
    this.title.setTitle("XRP20 | Buy Low and Stake to Earn");

    this.eventService.getLang().subscribe((val:any) => {
      selectedLang = val || 'en';
    });

    /* translate.onLangChange.subscribe((params: DefaultLangChangeEvent) => {
       const metaData = this.translate.instant('meta_data');
       const metaTitle = this.translate.instant('meta_title');
       console.log('metaData =', metaData)
       this.title.setTitle(metaTitle);
       this.meta.updateTag({ name: 'description', content: metaData });
     });*/
  }
}
